import { Branding, Database, DEFAULT_BRANDING, Timezone } from '@aston/foundation';
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, of, switchMap } from 'rxjs';

import { CONSOLE_API_ROOT } from './di';

@Injectable({ providedIn: 'root' })
export class InfrastructureService {

	apiRoot = inject(CONSOLE_API_ROOT)
	http = inject(HttpClient)

	fetchDatabases() {
		return this.apiRoot.pipe(switchMap(apiRoot => this.http.get<Database[]>(`${apiRoot}/api/Subsidiaries/database`).pipe(
			catchError(() => of([]))
		)))
	}

	fetchTimezones() {
		return this.apiRoot.pipe(switchMap(apiRoot => this.http.get<Timezone[]>(`${apiRoot}/api/Configuration/timezone`).pipe(
			catchError(() => of([]))
		)))
	}

	fetchBranding() {
		return this.apiRoot.pipe(switchMap(apiRoot => this.http.get<Branding[]>(`${apiRoot}/api/Configuration/branding`).pipe(
			catchError(() => of([
				{ name: 'Aston Ai', code: DEFAULT_BRANDING },
			]))
		)))
	}
}